'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_DrugDescription(name, formulation, strength, quantity) {
  this.Lapp_data_DrugDescription__f_name = null;
  this.Lapp_data_DrugDescription__f_formulation = null;
  this.Lapp_data_DrugDescription__f_strength = null;
  this.Lapp_data_DrugDescription__f_quantity = null;
  this.Lapp_data_DrugDescription__f_name = name;
  this.Lapp_data_DrugDescription__f_formulation = formulation;
  this.Lapp_data_DrugDescription__f_strength = strength;
  this.Lapp_data_DrugDescription__f_quantity = quantity;
}
export { $c_Lapp_data_DrugDescription as $c_Lapp_data_DrugDescription };
$c_Lapp_data_DrugDescription.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_DrugDescription.prototype.constructor = $c_Lapp_data_DrugDescription;
/** @constructor */
function $h_Lapp_data_DrugDescription() {
}
export { $h_Lapp_data_DrugDescription as $h_Lapp_data_DrugDescription };
$h_Lapp_data_DrugDescription.prototype = $c_Lapp_data_DrugDescription.prototype;
$c_Lapp_data_DrugDescription.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_DrugDescription.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1534474540, true);
});
$c_Lapp_data_DrugDescription.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_data_DrugDescription) && ((((this.Lapp_data_DrugDescription__f_name === x$0.Lapp_data_DrugDescription__f_name) && (this.Lapp_data_DrugDescription__f_formulation === x$0.Lapp_data_DrugDescription__f_formulation)) && (this.Lapp_data_DrugDescription__f_strength === x$0.Lapp_data_DrugDescription__f_strength)) && (this.Lapp_data_DrugDescription__f_quantity === x$0.Lapp_data_DrugDescription__f_quantity))));
});
$c_Lapp_data_DrugDescription.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_DrugDescription.prototype.productArity__I = (function() {
  return 4;
});
$c_Lapp_data_DrugDescription.prototype.productPrefix__T = (function() {
  return "DrugDescription";
});
$c_Lapp_data_DrugDescription.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lapp_data_DrugDescription__f_name;
      break;
    }
    case 1: {
      return this.Lapp_data_DrugDescription__f_formulation;
      break;
    }
    case 2: {
      return this.Lapp_data_DrugDescription__f_strength;
      break;
    }
    case 3: {
      return this.Lapp_data_DrugDescription__f_quantity;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_data_DrugDescription.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "formulation";
      break;
    }
    case 2: {
      return "strength";
      break;
    }
    case 3: {
      return "quantity";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_data_DrugDescription(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_DrugDescription)));
}
export { $isArrayOf_Lapp_data_DrugDescription as $isArrayOf_Lapp_data_DrugDescription };
var $d_Lapp_data_DrugDescription = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_DrugDescription, "app.data.DrugDescription", ({
  Lapp_data_DrugDescription: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_data_DrugDescription as $d_Lapp_data_DrugDescription };
//# sourceMappingURL=app.data.-Drug-Description.js.map
